import {Component, computed, input} from '@angular/core';

type IconBVariant = 'minus-grey' | 'minus-red' | 'add-primary' | 'close-grey' | 'close-red';

@Component({
  selector: 'icon-btn',
  imports: [],
  templateUrl: './icon-btn.component.html',
  styleUrl: './icon-btn.component.scss',
  // The host is a bare custom element; without this it renders inline and the badge sits at the
  // top of any row taller than 20px (e.g. beside a text input).
  host: {class: 'inline-flex items-center'},
})
export class IconBtnComponent {
  variant = input.required<IconBVariant>();
  disabled = input(false);
  ariaLabel = input<string>();

  // Full literal class strings — Tailwind scans .ts sources but cannot see interpolated names.
  private static readonly VARIANTS: Record<IconBVariant, {glyph: string; badge: string}> = {
    'minus-grey': {glyph: 'fa-minus', badge: 'bg-surface-400 hover:bg-surface-500'},
    'minus-red': {glyph: 'fa-minus', badge: 'bg-red-500 hover:bg-red-600'},
    'add-primary': {glyph: 'fa-plus', badge: 'bg-primary hover:bg-primary-600'},
    'close-grey': {glyph: 'fa-xmark', badge: 'bg-surface-400 hover:bg-surface-500'},
    'close-red': {glyph: 'fa-xmark', badge: 'bg-red-500 hover:bg-red-600'},
  };

  private readonly styles = computed(() => IconBtnComponent.VARIANTS[this.variant()]);

  glyphClass = computed(() => this.styles().glyph);
  badgeClass = computed(() => this.styles().badge);
}
